import React, { useEffect, useMemo, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { theme } from '_constants/theme';
import { selectBillList, selectSubscriptionsDetailsLoading } from '_store/billing/selector';
import { getSubscriptionsDetails } from '_store/billing/slice';
import { selectData as selectOrders, selectLoading as selectOrdersLoading } from '_store/orders/selector';

import Card from 'components/shared/layouts/Card';
import Text from 'components/shared/layouts/Text';

import BillsList from './BillsList';
import BillsTable from './BillsTable';

const StyledContainer = styled.div`
  padding-top: ${theme.spaces.large}px;

  @media ${theme.devices.tablet} {
    padding-top: ${theme.spaces.regular}px;
    padding-bottom: ${theme.spaces.regular}px;
  }
`;

const ROWS_PER_PAGE = 10;

const BillsView = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const ordersLoading = useSelector(selectOrdersLoading);
  const subscriptionsDetailsLoading = useSelector(selectSubscriptionsDetailsLoading);
  const orders = useSelector(selectOrders);
  const list = useSelector(selectBillList);

  const items = useMemo(() => {
    const start = (currentPage - 1) * ROWS_PER_PAGE;
    const end = start + ROWS_PER_PAGE;
    return list?.slice(start, end);
  }, [currentPage, list]);

  useEffect(() => {
    if (orders?.length) {
      dispatch(getSubscriptionsDetails({ orders }));
    }
  }, [orders]);

  return (
    <StyledContainer>
      <Card>
        <Text size={theme.fontSizes.large2X} weight={700} bottomSpace={theme.spaces.large} desktop>
          Recent Bills
        </Text>
        <Text size={theme.fontSizes.large} weight={700} bottomSpace={theme.spaces.large} centered mobile>
          Recent Bills
        </Text>
        {isMobile && (
          <BillsList
            loading={ordersLoading || subscriptionsDetailsLoading}
            items={items}
            pageCount={list?.length / ROWS_PER_PAGE}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
          />
        )}
        {!isMobile && (
          <BillsTable
            skeletonRowsNum={ROWS_PER_PAGE}
            loading={ordersLoading || subscriptionsDetailsLoading}
            items={items}
            pageCount={list?.length / ROWS_PER_PAGE}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
          />
        )}
      </Card>
    </StyledContainer>
  );
};

export default BillsView;
